import * as React from 'react';
import { Section } from '../../uiComponents/layout/Section';
import { Row, Col } from '../../uiComponents/bootstrap-components/BootstrapComponents';
import { MultipleChoiceSpoergsmaal } from '../../models/MultipleChoiceSpoergsmaal';
import KonkurrenceDelopgaveSvarmulighed from './KonkurrenceDelopgaveSvarmulighed';

export interface KonkurrenceDelopgaveSpoergsmaalProps {
    index: number;
    numberOfQuestions: number;
    spoergsmaal: MultipleChoiceSpoergsmaal;
}

class KonkurrenceDelopgaveSpoergsmaal extends React.Component<KonkurrenceDelopgaveSpoergsmaalProps, any> {
    constructor(props: KonkurrenceDelopgaveSpoergsmaalProps) {
        super(props);
    }

    getIndexText() {
        return '' + this.props.index + '/' + this.props.numberOfQuestions;
    }

    getSvarmuligheder() {
        return this.props.spoergsmaal.multipleChoiceSvarmuligheder.map((k, i) => {
            return <KonkurrenceDelopgaveSvarmulighed key={i} svarmulighed={k} disabled={true}/>;
        });
    }

    render() {
        return (
            <Section className='delopgavespoergsmaal'>
                <Row>
                    <Col md={3} className='spoergsmaal-index'>
                        <h4>{this.getIndexText()}</h4>
                    </Col>
                    <Col md={8}>
                        <h4>{this.props.spoergsmaal.spoergsmaal}</h4>
                    </Col>
                </Row>
                <br />
                <Row>
                    <Col md={8} mdOffset={3}>
                        <ul className='delopgavesvarmuligheder'>
                            {this.getSvarmuligheder()}
                        </ul>
                    </Col>
                </Row>
            </Section>
        );
    }
}

export default KonkurrenceDelopgaveSpoergsmaal;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/konkurrence/KonkurrenceDelopgaveSpoergsmaal.tsx